import { getCurrentVendor, Vendor } from '@studio/design-system/themes/vendor.js';
import type { ReactElement } from 'react';
import * as HiveSelect from './vendor/hive/select.js';
import * as IrisSelect from './vendor/iris/select.js';

/** `<Select>` component. */
export const Select = (): ReactElement => {
  const vendor = getCurrentVendor();

  if (vendor === Vendor.IRIS) {
    return <IrisSelect.Select />;
  }

  return <HiveSelect.Select />;
};
